export interface IUserInfoByEmailRequest {
  email: string | null;
}
export interface IUserInfoByIDRequest {
  userID: string | null;
}

export enum OrgUserRoles {
  financial_advisor = 'financial_advisor',
  para_planner = 'para_planner',
  administrator = 'administrator',
  executive_officer = 'executive_officer',
  compliance_officer = 'compliance_officer',
  relationship_manager = 'relationship_manager',
  super_administrator = 'super_administrator',
  fbs_administrator = 'fbs_admin',
  fbs_member = 'fbs_user',
  business_architect = 'business_architect',
}

export interface IUserInfo {
  id: string;
  createdAt: string;
  updatedAt: string;
  email: string;
  userName: string;
  title: string;
  firstName: string;
  lastName: string;
  mobile: string;
  isMobile2faEnabled: boolean;
  isEmail2faEnabled: boolean;
  userGroup: string;
  role: string;
  orgRole: OrgUserRoles[] | null;
  userStatus: string;
  accessibleEntityType: string;
  accessibleEntityID: string;
  fbsUserCreationEnabled: boolean;
}

export interface IAdvisorInfo {
  advisorID: string;
  advisorUserID: string;
  name: string;
  bio: string;
  logoID: string;
  pendingMeeting: boolean;
}

export interface IAdvisorDashboard {
  caseID: string;
  clientStatus: string;
  gdpr: {
    isSigned: boolean;
    signedDate: string;
  };
  advisor: IAdvisorInfo;
  aboutYou: boolean;
}
export interface IUserInfoByResponse {
  userInfo: IUserInfo;
}
export interface IUserInfoByIDResponse {
  responseItems: IUserInfo[];
}

export interface ICheckProfileSetupExistsRequest {
  uniqueIdentifier: string;
  workflowName: string;
}

export interface IWorkflowInstance {
  id: string;
  workflowConfigurationId: string;
  workflowInstanceStatus: string;
  workflowConfigurationName: string;
  sequenceID: number;
  stateName: string;
  uniqueIdentifier: string;
  currentStateId: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  lastUpdatedAt: string;
}

export interface ICheckProfileSetupExistsResponse {
  workflowInstance: IWorkflowInstance;
}

export interface IGetFinancialAvisorsListRequest {
  accessibleEntityID: string;
  orgRole: string[];
}

export interface IFinancialAdvisorDetails {
  id: string;
  createdAt: string;
  updatedAt: string;
  email: string;
  userName: string;
  title: string;
  firstName: string;
  lastName: string;
  mobile: string;
  countryCode: string;
  isMobile2faEnabled: boolean;
  isEmail2faEnabled: boolean;
  userGroup: string;
  role: string;
  orgRole: string[];
  userStatus: string;
  accessibleEntityType: string;
  accessibleEntityID: string;
}

export interface IGetFinancialAvisorsListResponse {
  responseItems: IFinancialAdvisorDetails[];
}

export interface IAdvisorUser {
  advisorUserID: string;
  fullName: string;
  email: string;
  disableDeleteIcon: boolean;
}

export interface IGetAdvisorUserListResponse {
  advisorUsers: IAdvisorUser[];
}

export interface IGetAdvisorUserListRequest {
  caseID: string;
  isAddingAccess?: boolean;
  emailORNameFilter?: string;
}

export interface IAddAdvisorUserRequest {
  caseID: string;
  advisorUserID: string;
}

export interface IRemoveAdvisorUserRequest {
  caseID: string;
  advisorUserID: string;
}
